import type { FamilyTabKey } from '../../utils/familyInboxRoute'

export const FAMILY_TAB_SCREEN_GUIDES: Record<FamilyTabKey, string> = {
  today: 'family.today',
  book: 'family.book',
  work: 'family.work',
  progress: 'family.progress',
  class: 'family.class',
  more: 'family.more',
}

export const familyScreenGuideId = (
  activeTab: FamilyTabKey | string | null | undefined,
): string | undefined => {
  if (!activeTab) return undefined
  const normalized = activeTab.toLowerCase() as FamilyTabKey
  return FAMILY_TAB_SCREEN_GUIDES[normalized]
}
